import { FC, useState } from "react";
import { Task, TaskStatus } from "../../../../types/task";
import styles from "./index.module.scss";
import cn from "classnames";
import { IconClose, Loading, Notification } from "@quark/design";
import TaskAction from "./task-action";

interface TaskItemProps {
  task: Task;
  onClose?: () => void;
}

const TaskName: FC<{ task: Task }> = ({
  task,
}) => {
  let typeName = '';
  switch (task.task_type) {
    case 'edit_code':
      typeName = "代码题";
      break;
    case 'edit_blog':
      typeName = "博客文章";
      break;
    case 'edit_page':
      typeName = "学习页";
      break;
    default:
      typeName = "未知类型任务";
  }

  return (
    <>
      <div>#{task.extra_data.id}. {task.extra_data.title} </div>
      <div className={styles.tag}>
        {typeName}
      </div>
    </>
  )
}

const TaskStatus: FC<{ status: TaskStatus }> = ({ status }) => {
  if (status === 'undo') {
    return (
      <div className={cn(styles.tag, styles.undo)}>未开始</div>
    )
  }
  if (status === 'doing') {
    return (
      <div className={cn(styles.tag, styles.doing)}>进行中</div>
    )
  }
  if (status === 'done') {
    return (
      <div className={cn(styles.tag, styles.done)}>已完成</div>
    )
  }
  if (status === 'check') {
    return (
      <div className={cn(styles.tag, styles.check)}>待审核</div>
    )
  }
  return (
    <div className={cn(styles.tag, styles.unknown)}>未知状态</div>
  )
}

const TaskItem: FC<TaskItemProps> = ({
  task,
  onClose = () => { },
}) => {
  const [taskVisible, setTaskVisible] = useState<boolean>(false);
  const [taskUrl, setTaskUrl] = useState<string>('');
  const [taskLoaded, setTaskLoaded] = useState<boolean>(false);

  // 根据环境设置host
  const host = process.env.NODE_ENV === 'development' ? 'http://localhost:5173' : 'https://edit.py2fun.com';

  const getEditUrl = (readonly = false) => {
    const query = readonly ? '?kiosk=true&readonly=true' : '?kiosk=true';
    if (task.task_type === 'edit_code') {
      return `${host}/code/${task.extra_data.id}${query}`
    }
    if (task.task_type === 'edit_blog') {
      return `${host}/blog/${task.extra_data.id}${query}`
    }
    if (task.task_type === 'edit_page') {
      return `${host}/page/${task.extra_data.id}${query}`
    }
    return '';
  }

  const getPreviewUrl = () => {
    if (task.task_type === 'edit_code') {
      return `/learn/#/problemset/all/code/${task.extra_data.id}?redirect=%2Fproblemset%2Fall%2F1`
    }
    if (task.task_type === 'edit_blog') {
      return `https://edu.py2fun.com/articles/${task.extra_data.id}`
    }
    if (task.task_type === 'edit_page') {
      return ''
    }
    return '';
  }

  const showEditor = (readonly = false) => {
    setTaskUrl(getEditUrl(readonly));
    setTaskVisible(true);
    setTaskLoaded(false);
  }

  const preview = () => {
    const url = getPreviewUrl();
    if (!url) {
      Notification.error('暂不支持预览');
      return;
    };
    window.open(url);
  }

  return (
    <>
      <div className={styles.task}>
        <div className={styles.header}>
          <TaskName task={task} />
          <TaskStatus status={task.status} />
          <div style={{ flex: 1 }}></div>
          <TaskAction
            task={task}
            onEdit={showEditor}
            onStart={showEditor}
            onSubmit={onClose}
            onView={preview}
          />
        </div>
        <div className={styles.tips}>任务指定时间: {task.assign_time}</div>
      </div>

      {
        taskVisible && (
          <div className={styles.editor}>
            <div className={styles.content}>
              <div className={styles.close} onClick={() => {
                setTaskVisible(false)
                onClose();
              }}>
                <IconClose />
              </div>
              {!taskLoaded && <Loading style={{ marginTop: 200 }} />}
              <iframe src={taskUrl} onLoad={() => setTaskLoaded(true)} />
            </div>
          </div>
        )
      }
    </>

  )
};

export default TaskItem;
